import { NewDialog, PartialObj } from ".";

function responseFormatter(data: Record<string, any>) {
	const type = data.type ?? data.responseType

	if(type === "flow") {
		return {
			flowName: data.flowName,
			nodeId: data.nodeId || undefined,
		}
	}

	if(type === "message") {
		const res: Record<string, any> = {
			messages: data.messages,
			isRandom: data.isRandom ?? false,
		}
		const filteredSuggestions = data.suggestions?.filter((item: string) => item.trim()) ?? []
		if(filteredSuggestions.length) {
			res.suggestions = filteredSuggestions
		}
		return res
	}

	return {}
}

export function getPayloadFromDialog(dialog: NewDialog) {
	const payload: Record<string, any> = {
		title: dialog.title,
		dialogType: dialog.dialogType,
		dialogValue: dialog.dialogValue,
		responseType: dialog.responseType,
	}

	if(dialog.responseType === "flow" || dialog.responseType === "message") {
		payload.response = responseFormatter(dialog)
	}

	if(dialog.responseType === "service") {
		payload.serviceKey = dialog.serviceKey
		payload.actions = Object.entries(dialog.actions).reduce((acc, curr) => {
			const [key, value] = curr
			acc[key] = {
				type: value.type,
				response: responseFormatter(value),
			}
			return acc
		}, {} as Record<string, any>)
	}

	return payload
}

export function validateDialog(errors: PartialObj<NewDialog>, dialog: NewDialog) {
	const formatter = (prefix: string) => `${prefix} shouldn't be empty`;

	if (!dialog.title.trim().length) {
		errors['title'] = formatter('Title');
	}

	if (!dialog.dialogValue.trim().length) {
		const prefix =
			dialog.dialogType === 'intent' ? 'Intent value' : 'Event type';
		errors['dialogValue'] = formatter(prefix);
	}

	if (!dialog.responseType.trim().length) {
		errors['responseType'] = formatter('Response type');
	}

	if (dialog.responseType === 'flow' && !dialog.flowName.trim().length) {
		errors['flowName'] = formatter('Flow Name');
	}

	if (dialog.responseType === 'message' && !dialog.messages.length) {
		errors['messages'] = formatter('Messages');
	}

	if (dialog.responseType === 'service' && !dialog.serviceKey.trim().length) {
		errors['serviceKey'] = formatter('Service');
	}

	if (
		dialog.responseType === 'service' &&
		!Object.keys(dialog.actions).length
	) {
		errors['actions'] = formatter('Actions');
	}

	return Object.keys(errors).length === 0;
}
